<script>
export default {
  name: 'EditSubtitlesModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['save', 'cancel'],
  data() {
    return {
      localItems: [],
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initializeData();
      }
    },
    data: {
      handler() {
        if (this.visible) {
          this.initializeData();
        }
      },
      deep: true,
    },
  },
  methods: {
    initializeData() {
      if (this.data && this.data.length > 0) {
        this.localItems = JSON.parse(JSON.stringify(this.data));
      } else {
        this.localItems = [{ title: '', description: '' }];
      }
    },
    addItem() {
      this.localItems.push({ title: '', description: '' });
    },
    removeItem(index) {
      if (this.localItems.length > 1) {
        this.localItems.splice(index, 1);
      }
    },
    updateItem(index, field, value) {
      this.localItems[index][field] = value;
    },
    handleSave() {
      const filteredItems = this.localItems.filter(
        (item) => item.title.trim() !== '' || item.description.trim() !== '',
      );
      this.$emit('save', filteredItems);
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <a-modal
    :open="visible"
    title="Edit Subtitles"
    :width="700"
    :z-index="2000"
    :footer="null"
    @cancel="handleCancel"
  >
    <div class="subtitles-editor">
      <div class="items-list">
        <div
          v-for="(item, index) in localItems"
          :key="index"
          class="item-block"
        >
          <div class="item-header">
            <span class="item-number">Block {{ index + 1 }}</span>
            <a-button
              v-if="localItems.length > 1"
              size="small"
              danger
              @click="removeItem(index)"
            >
              Remove
            </a-button>
          </div>
          <div class="item-fields">
            <div class="field-group">
              <span class="field-label">Title</span>
              <a-input
                :value="item.title"
                placeholder="Enter title"
                @input="e => updateItem(index, 'title', e.target.value)"
              />
            </div>
            <div class="field-group">
              <span class="field-label">Description</span>
              <a-textarea
                :value="item.description"
                placeholder="Enter description"
                :rows="3"
                @input="e => updateItem(index, 'description', e.target.value)"
              />
            </div>
          </div>
        </div>
      </div>

      <a-button
        type="dashed"
        class="add-button"
        @click="addItem"
      >
        + Add subtitle block
      </a-button>

      <div class="modal-footer">
        <a-button @click="handleCancel">Cancel</a-button>
        <a-button type="primary" @click="handleSave">Save</a-button>
      </div>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
.subtitles-editor {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 60vh;
  overflow-y: auto;
}

.items-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.item-block {
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.item-number {
  font-weight: 600;
  color: #262626;
}

.item-fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;

  .field-label {
    font-weight: 500;
    color: #595959;
    font-size: 13px;
  }
}

.add-button {
  width: fit-content;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
  margin-top: 8px;
}
</style>
